import React, { useRef } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

interface Review {
    title: string;
    content: string;
    name: string;
    role: string;
    location: string;
    image: string;
}

const reviews: Review[] = [
    {
        title: "Game Changer for Our Salon",
        content: "GrFeelaxo has completely transformed how we manage bookings! The online appointment system is seamless, and our customers love the convenience. The automation features have saved us so much time. Highly recommended for any salon!",
        name: "Priya S.",
        role: "Salon Owner",
        location: "Bangalore, India",
        image: "./image.webp"
    },
    {
        title: "User-Friendly and Powerful",
        content: "I was hesitant to switch to an online system, but Feelaxo made it effortless. The dashboard is easy to navigate, and tracking appointments is a breeze. Our staff finds it intuitive, and our clients appreciate the hassle-free booking experience!",
        name: "Rahul K.",
        role: "Beauty Studio Manager",
        location: "Delhi, India",
        image: "./image1.webp"
    },
    {
        title: "Boosted Our Business",
        content: "Since using Feelaxo, we've seen an increase in appointments and customer satisfaction. The automated reminders help reduce no-shows, and the analytics give us insights into peak booking times. A must-have for any salon looking to grow!",
        name: "Amit G.",
        role: "Hair Studio Owner",
        location: "Mumbai, India",
        image: "./image3.webp"
    },
    {
        title: "Good, But Needs More Features",
        content: "It’s a solid booking system, but I feel there could be more features for salon inventory management. Customer support is responsive, though, so I’m hopeful for future updates!",
        name: "Meena T.",
        role: "Beauty Consultant",
        location: "Chennai, India",
        image: "./image6.webp"
    },
    {
        title: "Game changer for my business!",
        content: "I've been running my salon for 8 years and Feelaxo is hands down the best software I've used. The appointment booking system is so intuitive - my clients love being able to book online 24/7. The automated reminders have reduced no-shows by 70%! The inventory management feature helps me track products perfectly, and I never run out of essentials anymore. Customer support is amazing too - they helped me migrate all my data seamlessly. Worth every penny!",
        name: "Mayank K.",
        role: "Salon Owner",
        location: "Hyderabad, India",
        image: "./image4.webp"
    },
    {
        title: "Makes my daily routine so much easier",
        content: "As someone who's not super tech-savvy, I was worried about learning new software. But Feelaxo is incredibly user-friendly! I can see my entire day's schedule at a glance, access client history instantly, and process payments in seconds. My clients also love the text reminders and the ability to reschedule online. It's made my work life so much more organized!",
        name: "Maria Rodriguez",
        role: "Hair Stylist",
        location: "Kolkata, India",
        image: "./image7.webp"
    },
    {
        title: "Streamlined our entire operation",
        content: "Managing a 12-chair salon was becoming overwhelming until we found Feelaxo. The staff scheduling feature is brilliant - I can see everyone's availability and assign appointments efficiently. The reporting dashboard gives me real-time insights into our revenue and staff performance. The commission tracking saves me hours of manual calculations. We've increased our booking efficiency by 45% since switching. Highly recommend!",
        name: "David Chen",
        role: "Spa Manager",
        location: "Pune, India",
        image: "./image5.webp"
    },
    {
        title: "Great software with room for minor improvements",
        content: "Overall very satisfied with Feelaxo. The core features work excellently – manage appointments, view calendar, POS & Billing, client management are all smooth. The only reason I'm giving 4 stars instead of 5 is that I'd like to see more customizable report options, But for the price point, it's definitely great value.",
        name: "Jennifer L.",
        role: "Beauty Salon Owner",
        location: "Ahmedabad, India",
        image: "./image8.webp"
    }
];


const ReviewCard: React.FC<Review> = ({ title, content, name, role, location, image }) => (
    <div className="bg-gray-100 rounded-xl shadow-md p-6 w-[230px] md:w-[340px] lg:w-[290px] flex flex-col justify-between flex-shrink-0">
        <div>
            <div className="flex items-center mb-3 text-yellow-500">
                {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i}>★</span>
                ))}
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-900">{title}</h3>
            <p className="text-gray-700 font-medium text-sm">{content}</p>
        </div>
        <div className="flex items-center mt-6">
            <img
                src={image}
                alt={name}
                className="w-10 h-10 rounded-full object-cover mr-3"
            />
            <div>
                <div className="font-medium text-gray-800">{name}</div>
                <div className="text-sm text-gray-600 italic">{role}</div>
                <div className="text-sm text-gray-500">{location}</div>
            </div>
        </div>
    </div>
);


const Testimonial = () => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const scrollAmount = 350;

    const scrollLeft = () => {
        scrollRef.current?.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    };

    const scrollRight = () => {
        scrollRef.current?.scrollBy({ left: scrollAmount, behavior: "smooth" });
    };

    return (
        <section className="p-4 md:p-6 mt-4 bg-gray-50 relative">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900 text-center">Reviews</h2>

            <div className="relative">
                {/* Left arrow */}
                <button
                    onClick={scrollLeft}
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white p-2 md:p-3 rounded-full shadow hover:bg-gray-100"
                >
                    <FaArrowLeft className="text-gray-700 text-xl" />
                </button>

                {/* Right arrow */}
                <button
                    onClick={scrollRight}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white p-2 md:p-3 rounded-full shadow hover:bg-gray-100"
                >
                    <FaArrowRight className="text-gray-700 text-xl" />
                </button>

                <div
                    ref={scrollRef}
                    className="flex space-x-4 overflow-x-auto scroll-smooth py-4 px-2 md:px-4"
                    style={{ scrollbarWidth: "none" }}
                >
                    {reviews.map((review, index) => (
                        <ReviewCard key={index} {...review} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonial;

// this is the code for testimonial